__turbopack_context__.v({
  "arrow": "_1WtOzq_arrow",
  "card": "_1WtOzq_card",
  "cardBody": "_1WtOzq_cardBody",
  "cardImage": "_1WtOzq_cardImage",
  "cardStack": "_1WtOzq_cardStack",
  "cardTitle": "_1WtOzq_cardTitle",
  "description": "_1WtOzq_description",
  "header": "_1WtOzq_header",
  "heading": "_1WtOzq_heading",
  "inner": "_1WtOzq_inner",
  "meta": "_1WtOzq_meta",
  "metaDate": "_1WtOzq_metaDate",
  "metaPrimary": "_1WtOzq_metaPrimary",
  "metaSeparator": "_1WtOzq_metaSeparator",
  "readMore": "_1WtOzq_readMore",
  "section": "_1WtOzq_section",
});
